module.exports = __webpack_public_path__ + "img/outlander2022_safe.2aca2c06.jpg";